import { Role } from '@core/referential/role.enum'
import { GetUserSchemaResponse } from '@shared/schema/user.get.schema'
import { queryOptions } from '@tanstack/react-query'

import { type QueryOptionsData } from '@/@types/query'
import { apiFetch } from '@/lib/api-fetch'

export function usersQuery(params?: { roles?: Array<Role> }) {
  return queryOptions({
    queryKey: ['users', params],
    async queryFn() {
      const searchParams = new URLSearchParams()

      if (params?.roles) {
        searchParams.append('roles', params.roles.join(','))
      }

      const rawResponse = await apiFetch.get('user', { searchParams })

      if (!rawResponse.ok) {
        throw new Error('Failed to fetch users')
      }

      try {
        return await GetUserSchemaResponse.parseAsync(await rawResponse.json())
      } catch (error) {
        throw new Error('Failed to parse users response', { cause: error })
      }
    },
    staleTime: 1000 * 60 * 24, // 24 hours
  })
}

export type User = QueryOptionsData<typeof usersQuery>[number]
